<template>
    <div 
        v-tinymce="options"
        :key="renderKey"
        @mce-change="(add) => offerSectionSet({additionalInfo: add})"
        @mce-dirty="() => $emit('dirty')"
    >
        <div v-if="offerSections.additionalInfo" v-html="offerSections.additionalInfo"></div>
        <div v-else class="additional-info">
            <h3>{{ $t('additionalInfo.heading') }}</h3>
            <ul>
                <li v-if="offer.offerType_id !== 4">{{ $t('additionalInfo.trainerContact') }}</li>
                <li>{{ $t('additionalInfo.certificate') }}</li>
                <li v-if="offer.offerType_id === 4">{{ $t('additionalInfo.openCapacity') }}</li>
                <li v-else>{{ $tc('additionalInfo.capacity', capacity, { capacity }) }}</li>
            </ul>
            <p>{{ $t('additionalInfo.validUntil', { date: expireDate }) }}</p>
            <p>&nbsp;</p>
            <i18n path="additionalInfo.zoom" tag="p"><a place="link" :href="zoomTermsUrl" target="_blank"><b>{{ $t('additionalInfo.zoomTerms') }}</b></a></i18n>
        </div>
    </div>
</template>

<script>

import placeholder from './placeholder';
import { mapGetters, mapMutations } from 'vuex';
import { formatDate } from '../../misc/LocaleFormat';

export default {
    name: 'AdditionalInfo',
    props: {
        options: Object
    },
    mixins: [placeholder],
    data: function() {
        return {
            renderKey: 0
        };
    },
    computed: {
        ...mapGetters([
            'offer',
            'offerSections'
        ]),
        expireDate: function () {
            if(this.offer && this.offer.createdAt) {
                const [createdAt, _] = this.offer.createdAt.split(' ');
                let expireDate =  new Date(createdAt);
                expireDate.setMonth(expireDate.getMonth()+1);
                return formatDate(expireDate, this.offer.language || 'de');
            }
            return this.placeholder;
        },
        capacity: function () {
            return this.offer
                ? this.offer.capacity
                : this.placeholder;
        },
        zoomTermsUrl: function () {
            const language = this.offer ? this.offer.language : 'de';
            return `https://explore.zoom.us/${language}/eula-terms-of-service/`;
        }
    },
    methods: {
        ...mapMutations([
            'offerSectionSet',
        ])
    },
    watch: {
        offer: {
            handler: function () {
                this.renderKey++;
            },
            deep: true
        }
    }
}
</script>
